import Vue from 'vue'
import Vuex from 'vuex'

import user from '@/store/user'
import schedule from '@/store/schedule'
import dictionaries from '@/store/dictionaries'
import assessmentGenerated from './assessmentGenerated'

import locale from '@/store/locale'
import breakpoint from '@/store/breakpoint'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: true,

  modules: {
    user,
    schedule,
    dictionaries,
    assessmentGenerated,

    breakpoint,
    locale
  }
})
